import { convertHtmlToPlainText, formatNumber } from "@SeemplicityDev/shared";
import type { TextWidgetContent } from "./TextWidget";

export const TEXT_WIDGET_CHART_TYPE = "Text";

export const TEXT_WIDGET_DEFAULT_HEIGHT = 16;

export const TEXT_WIDGET_LABEL = "Text";

export const TEXT_WIDGET_STORED_NAME = "Text widget";

export const TEXT_WIDGET_CARD_BODY_CLASS = "text-widget-card-body";

export const TEXT_WIDGET_REMOVE_DIALOG_TITLE = "Remove Text Widget";

export const TEXT_WIDGET_MAX_CHARACTERS = 3_000;

export const getTextWidgetMaxCharactersMessage = (
  maxCharacters: number = TEXT_WIDGET_MAX_CHARACTERS
): string => `Text is limited to ${formatNumber(maxCharacters)} characters`;

// Line breaks are not counted, matching the editor counter and the backend.
export const countTextWidgetCharacters = (text: string): number =>
  text.replace(/\n/g, "").length;

export const isTextWidgetChartType = (chartTypeId?: string | null): boolean =>
  chartTypeId === TEXT_WIDGET_CHART_TYPE;

export const getTextWidgetBody = (
  queryDefinition: unknown
): TextWidgetContent | undefined => {
  const body = (queryDefinition as { body?: unknown } | null)?.body;
  if (!body || typeof body !== "object") {
    return undefined;
  }
  return typeof (body as TextWidgetContent).html === "string"
    ? (body as TextWidgetContent)
    : undefined;
};

export const isTextBodyEmpty = (body?: TextWidgetContent | null): boolean => {
  const hasText = !!body?.text?.trim();
  if (hasText) {
    return false;
  }
  if (!body?.html) {
    return true;
  }
  return !convertHtmlToPlainText(body.html);
};
